import React from "react";
import ReactDOM from "react-dom";
import { Presentation } from "./presentation";

ReactDOM.render(<Presentation />, document.getElementById("root"));
